import { SET_STYLES } from '../../utils/constants'

const initialState = {
  version: 1,
  components: null,
  icons: null,
  accounts: null,
  auth: null,
  beneficiaryTransfers: null,
  branch: null,
  calculator: null,
  dashboard: null,
  deposits: null,
  loans: null,
  offers: null,
  paydayLoans: null,
  payments: null,
  quickPay: null,
  requests: null,
  sendToMobile: null,
  settings: null,
  sideNav: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_STYLES:
      return { ...state, ...payload }
    default:
      return state
  }
}
